import React, { useEffect, useState } from 'react';
import { Card, Radio, Typography, Divider } from "antd";
const { Text } = Typography;
const ListLocadtrAssessment = [
	{
		criteria: "Dependence condition or Abuse Condition.",
		next_step: {
			yes: {
				index: 2,
				care: ""
			},
			no: {
				index: 15,
				care: ""
			}
		}
	},
	{
		criteria: "Unable to participate in or comply with treatment outside 24-hour structured treatment setting.",
		next_step: {
			yes: {
				index: 4,
				care: ""
			},
			no: {
				index: 3,
				care: ""
			},
		}
	},
	{
		criteria: "Imminent health risk from continued alcohol or drug use.",
		next_step: {
			yes: {
				index: 4,
				care: ""
			},
			no: {
				index: 6,
				care: ""
			},
		}
	},
	{
		criteria: "Substantial deficits in functional skills.",
		next_step: {
			yes: {
				index: 5,
				care: ""
			},
			no: {
				index: undefined,
				care: "Inpatient Rehabilitation"
			},
		}
	},
	{
		criteria: "Complications or Co-morbidities requiring daily medical management/monitoring.",
		next_step: {
			yes: {
				index: undefined,
				care: "Inpatient Rehabilitation"
			},
			no: {
				index: undefined,
				care: "Intensive Residential Rehabilitation"
			},
		}
	},
	{
		criteria: "Established Opiate Dependence Condition.",
		next_step: {
			yes: {
				index: 7,
				care: ""
			},
			no: {
				index: 8,
				care: ""
			},
		}
	},
	{
		criteria: "Chooses to participate in Methadone Treatment.",
		next_step: {
			yes: {
				index: undefined,
				care: "Referral to Methadone Treatment"
			},
			no: {
				index: 8,
				care: ""
			},
		}
	},
	{
		criteria: "Substantial deficits in functional skills.",
		next_step: {
			yes: {
				index: 10,
				care: ""
			},
			no: {
				index: undefined,
				care: ""
			},
		}
	},
	{
		criteria: "Physical Health Care needs.",
		next_step: {
			yes: {
				index: 10,
				care: ""
			},
			no: {
				index: 11,
				care: ""
			},
		}
	},
	{
		criteria: "Inadequate social support system.",
		next_step: {
			yes: {
				index: undefined,
				care: "Outpatient Rehabilitation"
			},
			no: {
				index: 11,
				care: ""
			},
		}
	},
	{
		criteria: "Substantial risk of relapse",
		next_step: {
			yes: {
				index: undefined,
				care: "Intensive Outpatient"
			},
			no: {
				index: 12,
				care: ""
			},
		}
	},
	{
		criteria: "Moderate to severe dependence condition",
		next_step: {
			yes: {
				index: undefined,
				care: "Intensive Outpatient"
			},
			no: {
				index: undefined,
				care: "Outpatient, Non-Intensive"
			},
		}
	},
	{
		criteria: "Inadequate Living Environment",
		next_step: {
			yes: {
				index: 14,
				care: ""
			},
			no: {
				index: undefined,
				care: ""
			},
		}
	},
	{
		criteria: "Requires 24-hour day residential services and ongoing clinical support",
		next_step: {
			yes: {
				index: undefined,
				care: "Community Residence"
			},
			no: {
				index: undefined,
				care: "Supportive Living"
			},
		}
	},
	{
		criteria: "Significant Other.",
		next_step: {
			yes: {
				index: undefined,
				care: "Outpatient, Non-Intensive"
			},
			no: {
				index: undefined,
				care: "End"
			},
		}
	},
];
const LocadtrAssessment = ({ assessmentQuestions }) => {
	const [questions, setQuestions] = useState(() => {
		if (assessmentQuestions) {
			return assessmentQuestions;
		}
		const questionFromSession = JSON.parse(sessionStorage.getItem("assessmentQuestions"));
		if (questionFromSession) {
			return questionFromSession;
		}
		return [
			{
				index: 0,
				answer: null,
				care: null,
				criteria: ListLocadtrAssessment[0].criteria
			}
		];
	});
	
	const handleAnswerChange = (qIndex, answer) => {
		const currentItem = ListLocadtrAssessment[questions[qIndex].index];
		const next = currentItem.next_step[answer.toLowerCase()];

		// Build new questions list up to this point
		const newQuestions = questions.slice(0, qIndex + 1);
		newQuestions[qIndex] = {
			...newQuestions[qIndex],
			answer,
			care: next?.care || null,
			criteria: currentItem.criteria
		};

		// If there’s a next question (index), add it with its criteria
		if (next?.index !== undefined) {
			const nextIndex = next.index - 1;
			const nextItem = ListLocadtrAssessment[nextIndex];

			newQuestions.push({
				index: nextIndex,
				criteria: nextItem.criteria,
				answer: null,
				care: null,
			});
		};
		// Set the new state (this will remove any outdated branch)
		setQuestions(newQuestions);
		sessionStorage.setItem("assessmentQuestions", JSON.stringify(newQuestions));
	};
	
	useEffect(() => {
		if (assessmentQuestions) {
		  setQuestions(assessmentQuestions);
		}
	  }, [assessmentQuestions]);
	
	return (
		<div>
			{questions.map((q, i) => {
				const currentItem = ListLocadtrAssessment[q.index];
				return (
					<div key={i} >
						<Card bordered style={{ background: "#fafafa" }}>
							<Text strong>{currentItem.criteria}</Text>
							<br />
							<Radio.Group
								onChange={(e) => handleAnswerChange(i, e.target.value)}
								value={q.answer}
							>
								<Radio value="Yes">Yes</Radio>
								<Radio value="No">No</Radio>
							</Radio.Group>

							{q.care && (
								<div
									className='mt-4 px-4 py-3 bg-[#e6f7ff] rounded border border-[#91d5ff]'
								>
									<Text type="secondary">
										<span className='font-bold'>Indicated level of care:</span> {q.care}
									</Text>
								</div>
							)}
						</Card>
						{i < questions.length - 1 && <Divider />}
					</div>
				);
			})}

			{/* End message when last node has no next index */}
			{(() => {
				const last = questions[questions.length - 1];
				const next = ListLocadtrAssessment[last.index].next_step[last.answer?.toLowerCase()];
				return last.answer && next?.index === undefined ? (
					<Card
						style={{
							background: "#f6ffed",
							border: "1px solid #b7eb8f",
							marginTop: 10,
						}}
					>
						<Text type="success">
							<strong>Assessment Complete.</strong>
						</Text>
					</Card>
				) : null;
			})()}
		</div>
	)
}

export default LocadtrAssessment